import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client, throwFriendlyApiError } from '../common';

type Variables = { email: string };
type EmailCheckResponse = { data: { exists: boolean } };

export const useEmailCheck = createMutation<
  EmailCheckResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/customers/email_check',
      method: 'POST',
      data: variables,
    })
      .then((response) => response.data)
      .catch((err: any) => throwFriendlyApiError(err, 'check email')),
});
